/**
 * Entscheidet, ob ein fehlgeschlagener API-Request an Sentry gemeldet wird.
 * 401 gehört zum normalen Token-Refresh-Flow, andere 4xx sind erwartete/
 * behandelte Client-Fehler (Validierung, Not-Found, …), abgebrochene Requests
 * (React-Cleanup) sind beabsichtigt. Nur 5xx und Netzwerkfehler (kein
 * response, z. B. DNS/Timeout) deuten auf einen echten Bug hin – siehe
 * server/CLAUDE.md-Konvention, dass 500 = "unerwarteter Systemfehler" ist.
 */
export function shouldReportToSentry(error) {
  if (error.code === "ERR_CANCELED") return false;
  const status = error.response?.status;
  return status == null || status >= 500;
}
